import "./_skeleton.scss";

const Skeleton = (props) => {

    return <div className="skeleton-block">
        {props.title ? <div className="skeleton-title">{props.title}</div> : null}
    </div>
}

export default Skeleton;